import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@aviary";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { l } from "@unauthenticated/catalog/locales/i18n";

import { Menu } from "../Menu";
import { Learn } from "../Menu/MenuItems/Learn";
import { Product } from "../Menu/MenuItems/Product";
import { Support } from "../Menu/MenuItems/Support";
import { OpenMobileNavContainer } from "../OpenMobileNavContainer";

import * as styles from "./OpenMobileNavigation.styles";

const OpenMobileNavigation = () => {
  const { t } = useTranslation();

  const [menuItem, setMenuItem] = useState<string>("");

  const setItem = (chosen: string) => {
    menuItem === chosen ? setMenuItem("") : setMenuItem(chosen);
  };

  const renderMenu = () => {
    if (menuItem !== "") {
      return (
        <div>
          {menuItem === t(l.navigation.OurPlatform) && <Product />}
          {menuItem === t(l.navigation.Learn) && <Learn />}
          {menuItem === t(l.navigation.Support) && <Support />}
        </div>
      );
    }
  };

  return (
    <OpenMobileNavContainer>
      <nav css={styles.nav}>
        <ul css={styles.ul}>
          <li css={styles.li}>
            <Menu activeItem={menuItem} setItem={setItem} menuItem={t(l.navigation.OurPlatform)}>
              {renderMenu()}
            </Menu>
          </li>
          <li css={styles.li}>
            <Menu activeItem={menuItem} setItem={setItem} menuItem={t(l.navigation.Learn)}>
              {renderMenu()}
            </Menu>
          </li>
          <li css={styles.li}>
            <Menu activeItem={menuItem} setItem={setItem} menuItem={t(l.navigation.Support)}>
              {renderMenu()}
            </Menu>
          </li>
        </ul>
        <ul css={styles.buttonUl}>
          <li css={styles.buttonLi}>
            <Button css={styles.buttonContainer} isFullWidth href={openCatalogRoutes.signUp}>
              {t(l.navigation.CreateAccount)}
            </Button>
          </li>
        </ul>
      </nav>
    </OpenMobileNavContainer>
  );
};

export { OpenMobileNavigation };
